@if (Company) {
  <app-display-card>
    <div
      class="row justify-content-center align-items-center"
      (click)="
        collapseCompanyBackgroundChecks = !collapseCompanyBackgroundChecks
      "
    >
      <div class="col">
        <h3>
          {{
            Company.country === 'US'
              ? 'LexisNexis Background Validation'
              : 'Canadian Background Validation'
          }}
        </h3>
      </div>
      <div class="col-3 text-end">
        <i
          class="bi bi-chevron-{{
            collapseCompanyBackgroundChecks ? 'up' : 'down'
          }} fs-32 fw-semibold"
        ></i>
      </div>
    </div>
    @if (Company.country === 'US') {
      <div
        class="inner-panel rounded"
        [(ngbCollapse)]="collapseCompanyBackgroundChecks"
      >
        @if (!collapseCompanyBackgroundChecks) {
          <div class="row mx-2">
            <div class="col">
              <div class="row">
                <div class="col-3"></div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3 d-flex flex-column">
                    <label class="form-label align-self-center">{{
                      form && form.controls.riskLevel.value === 0
                        ? 'Global'
                        : 'Risk Level ' + form.controls.riskLevel.value
                    }}</label>
                  </div>
                }
              </div>
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label"
                    >Secretary of State In Good Standing Validation</label
                  >
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    <form [formGroup]="form">
                      <div class="form-check-group mt-0">
                        <input
                          id="companyInGoodStanding{{ form.controls.id.value }}"
                          type="checkbox"
                          class="form-check-input"
                          formControlName="companyInGoodStanding"
                        />
                        <label
                          for="companyInGoodStanding{{
                            form.controls.id.value
                          }}"
                          class="form-check-label"
                          >Required?</label
                        >
                      </div>
                    </form>
                  </div>
                }
              </div>
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label"
                    >Corporate Identify Verification</label
                  >
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    <form [formGroup]="form">
                      <div class="form-group">
                        <select
                          class="form-select"
                          formControlName="companyIdentity"
                        >
                          @for (
                            item of corporateIdentityMap | keyvalue;
                            track item
                          ) {
                            <option [ngValue]="item.value">
                              {{ item.key }}
                            </option>
                          }
                        </select>
                      </div>
                    </form>
                  </div>
                }
              </div>
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label">Corporate Watchlist</label>
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    <form [formGroup]="form">
                      <div class="form-group">
                        <select
                          class="form-select"
                          formControlName="companyWatchlist"
                        >
                          @for (
                            item of ownerWatchlistMap | keyvalue;
                            track item
                          ) {
                            <option [ngValue]="item.value">
                              {{ item.key }}
                            </option>
                          }
                        </select>
                      </div>
                    </form>
                  </div>
                }
              </div>
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label">Corporate Bankruptcy Search</label>
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    <form [formGroup]="form">
                      <div class="form-group">
                        <select
                          class="form-select"
                          formControlName="bankruptcy"
                        >
                          @for (
                            item of corporateBankruptcySearchMap | keyvalue;
                            track item
                          ) {
                            <option [ngValue]="item.value">
                              {{ item.key }}
                            </option>
                          }
                        </select>
                      </div>
                    </form>
                  </div>
                }
              </div>
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label"
                    >Corporate Liens and Judgements</label
                  >
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    <form [formGroup]="form">
                      <div class="form-group">
                        <select
                          class="form-select"
                          formControlName="companyLiens"
                        >
                          @for (
                            item of companyLiensMap
                              | keyvalue: keyValuePairDefaultOrder;
                            track item
                          ) {
                            <option [ngValue]="item.value">
                              {{ item.key }}
                            </option>
                          }
                        </select>
                      </div>
                    </form>
                  </div>
                }
              </div>
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label">W9 Validation</label>
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    <form [formGroup]="form">
                      <div class="form-check-group m-0">
                        <input
                          id="isW9Checked{{ form.controls.id.value }}"
                          type="checkbox"
                          class="form-check-input"
                          formControlName="isW9Checked"
                        />
                        <label
                          for="isW9Checked{{ form.controls.id.value }}"
                          class="form-check-label"
                          >Required?</label
                        >
                      </div>
                    </form>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (Company.country === 'CA') {
      <div
        class="inner-panel rounded"
        [(ngbCollapse)]="collapseCompanyBackgroundChecks"
      >
        @if (!collapseCompanyBackgroundChecks) {
          <div class="row mx-2">
            <div class="col">
              <div class="row">
                <div class="col-3"></div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3 d-flex flex-column">
                    <label class="form-label align-self-center">{{
                      form && form.controls.riskLevel.value === 0
                        ? 'Global'
                        : 'Risk Level ' + form.controls.riskLevel.value
                    }}</label>
                  </div>
                }
              </div>
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label">Corporation In Good Standing</label>
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    <form [formGroup]="form">
                      <div class="form-check-group mt-0">
                        <input
                          id="companyInGoodStanding{{ form.controls.id.value }}"
                          type="checkbox"
                          class="form-check-input"
                          formControlName="companyInGoodStanding"
                        />
                        <label
                          for="companyInGoodStanding{{
                            form.controls.id.value
                          }}"
                          class="form-check-label"
                          >Required?</label
                        >
                      </div>
                    </form>
                  </div>
                }
              </div>
              <div class="row py-2">
                <div class="col-3">
                  <label class="form-label">Business Verification Check</label>
                </div>
                @for (form of complianceSettingForms; track form) {
                  <div class="col-3">
                    @if (getComplianceSettingForm(form)) {
                      <div>
                        <div class="form-group">
                          <div class="form-check-group mt-0">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              [ngModel]="
                                getComplianceSettingForm(form)!
                                  .businessVerification
                              "
                              (ngModelChange)="
                                canadianBusinessVerificationCheck(form, $event)
                              "
                            />
                            <label class="form-check-label ps-2 mt-0"
                              >Required?</label
                            >
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
  </app-display-card>
}
